import {Divider, Stack, Typography} from '@mui/material'
import {colors} from '@/constants'
import React, {useMemo} from 'react'
import {ReactComponent as OkIcon} from '@/assets/svgs/OkIcon.svg'

const Index = ({
  step,
  sum,
  owned,
  start,
}: {
  start: number
  sum: number
  owned: number
  step: {checked: boolean; value: number; name: string; nextStep: boolean}
}) => {
  const color = useMemo(() => {
    if (step.name.includes('Step')) {
      if (!step.nextStep) {
        return colors.gray
      }
      return colors.white
    }
    return colors.orange
  }, [step])

  return (
    <Stack
      width="max-content"
      style={{transform: 'translate(-50%, 0)'}}
      position="absolute"
      top="-37px"
      alignItems="center"
      gap="12px"
      left={((step.value - start) / sum) * 90 + '%'}>
      <Typography variant="body2" color={color}>
        {step.name}
      </Typography>
      {!step.checked ? (
        <Divider
          orientation="vertical"
          color={colors.yellow}
          style={{width: '1px', height: '20px'}}
        />
      ) : (
        <Stack height="20px" />
      )}
      <Stack marginTop="10px">
        {step.checked ? (
          <OkIcon />
        ) : step.nextStep ? (
          <Typography fontSize="16px" textAlign="center">
            <span style={{color: colors.yellow}}>{owned}&nbsp;</span>\{' '}
            {step.value} <br />
            Hexatiles
          </Typography>
        ) : (
          <Typography variant="body2" color={color}>
            {step.value}
          </Typography>
        )}
      </Stack>
    </Stack>
  )
}

export default Index
